<div fxLayout="column" fxLayoutGap="30px" [formGroup]="contractBalanceForm">
  <div fxLayout="column" fxFlex="100" fxLayoutGap="15px" fxLayout.lt-lg="column">
      <div fxLayout="row" fxFlex="100">
        <h3 mat-line>Dodaj saldo początkowe do umowy: <br>
          <ng-container *ngIf="contractObject?.partner">
            {{ contractObject?.partner?.shortName}},
          </ng-container>
          <ng-container *ngIf="contractObject?.ofwca">
            {{ contractObject?.ofwca?.fullName}},
          </ng-container>
          {{ contractObject?.type?.name }} (nr: {{contractObject?.number}})
        </h3>
      </div>
    <div fxLayout="row" fxFlex="100">
      <mat-form-field fxFlex="100">
        <mat-label>Kwota</mat-label>
        <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="initialBalanceControl">
        <mat-error *ngIf="initialBalanceControl.hasError('required')">To pole jest wymagane</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxFlex="100">
      <mat-form-field fxFlex="100">
        <mat-label>Uwagi</mat-label>
        <textarea [required]="true" [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
        <mat-error *ngIf="noteControl.hasError('required')">To pole jest wymagane</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
      <button (click)="sendForm()"
              [class.spinner]="processingRequest"
              mat-stroked-button color="primary"
              [disabled]="!contractBalanceForm.valid || processingRequest"><mat-icon>save</mat-icon><span> Zapisz</span>
      </button>
      <!--    <button (click)="sendForm()"-->
      <!--            [class.spinner]="processingRequest"-->
      <!--            mat-stroked-button color="primary"-->
      <!--    ><mat-icon>save</mat-icon> <span> Zapisz</span></button>-->
      <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    </div>
    <div fxLayout="row" fxFlex="100" >
        <h4 class="mb-0">Podsumowanie</h4>
      </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="start start">
      <app-detail fxFlex="33" header="Saldo wprowadzone" [value]=""> {{(contractBalanceInitialBalanceSwap === null ? 0 : sum(contractBalanceInitialBalanceSwap , initialBalanceControl.value)) | number:'1.2-2'}} zł
      </app-detail>
      <app-detail fxFlex="33" header="Wypłacono z salda" [value]=""> {{(contractBalanceInitialBalanceNet === null ? 0 : sum(contractBalanceInitialBalanceNet , initialBalanceControl.value)) | number:'1.2-2'}} zł
      </app-detail>
      <app-detail fxFlex="33" header="Do wypłacenia" [value]="">{{(contractBalanceToPayNet === null ? 0 : sum(contractBalanceToPayNet , initialBalanceControl.value)) | number:'1.2-2'}} zł
      </app-detail>
<!--      <app-detail fxFlex="20" header="Wypłacono" [value]="">{{(contractBalancePaid === null ? 0 : contractBalancePaid) | number:'1.2-2'}} zł-->
<!--      </app-detail>-->
<!--      <app-detail fxFlex="20" header="Ogólne" [value]="">{{(contractBalanceTotalCommission === null ? 0 : (contractBalanceTotalCommission + initialBalanceControl.value)) | number:'1.2-2'}} zł-->
<!--      </app-detail>-->
    </div>
    <ng-container *ngIf="contractBalanceObject?.contractInitialBalances.length">
      <div fxLayout="row" fxFlex="100" >
        <h4 class="mb-0">Historia zmian</h4>
      </div>
      <table mat-table [dataSource]="contractBalanceObject?.contractInitialBalances">

        <ng-container matColumnDef="net">
          <th mat-header-cell *matHeaderCellDef>Kwota salda</th>
          <td mat-cell *matCellDef="let element">
            {{element.initialBalanceNet | number:'1.2-2'}} zł
          </td>
        </ng-container>
        <ng-container matColumnDef="note">
          <th mat-header-cell *matHeaderCellDef>Uwagi</th>
          <td mat-cell *matCellDef="let element">
            {{element.note}}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Data dodania</th>
          <td mat-cell *matCellDef="let element">
            {{element.createdAt | date:'y-MM-dd'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.createdBy">
              <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
            </ng-container>
            <ng-container *ngIf="element.createdBy === null">
              <a class="default-link">System</a>
            </ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>
      </table>
    </ng-container>
  </div>
</div>
